import Vue from "vue";
import { SET_SAMPLE_LABEL } from "@/store/mutation.type";
import Component from "vue-class-component";

@Component
export default class SampleLabelMixin extends Vue {
  get sampleLabel() {
    return this.$store.state["sample-label"].sampleLabel;
  }
  set sampleLabel(detail: any) {
    this.$store.commit(SET_SAMPLE_LABEL, detail);
  }
}
